// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"538328c2","738":"177d95c6","947":"99affc9b"}[chunkId] + ".chunk.js";
};